import styled from "styled-components";
import { pxIntoRem } from "../../utils/pxIntoRem";

const AuthBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
`;

const AuthFormWrapper = styled.div`
  background: white;
  padding: ${pxIntoRem(40)};
  border-radius: ${pxIntoRem(12)};
  box-shadow: 0 ${pxIntoRem(2)} ${pxIntoRem(12)} rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: ${pxIntoRem(420)};
  border: ${pxIntoRem(1)} solid #e9ecef;
`;

const AuthFormTitle = styled.h2`
  text-align: center;
  margin-bottom: ${pxIntoRem(32)};
  color: #212529;
  font-size: ${pxIntoRem(28)};
  font-weight: 600;
  letter-spacing: -0.02em;
`;

const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${pxIntoRem(20)};
`;

const AuthFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxIntoRem(6)};
`;

const AuthInput = styled.input<{ $hasError?: boolean }>`
  padding: ${pxIntoRem(14)} ${pxIntoRem(16)};
  border: ${pxIntoRem(1)} solid ${(props) => (props.$hasError ? "#e74c3c" : "#dee2e6")};
  border-radius: ${pxIntoRem(8)};
  font-size: ${pxIntoRem(15)};
  transition: all 0.2s ease;
  background: #fff;
  color: #212529;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? "#e74c3c" : "#495057")};
    box-shadow: 0 0 0 ${pxIntoRem(3)}
      ${(props) => (props.$hasError ? "rgba(231, 76, 60, 0.1)" : "rgba(73, 80, 87, 0.1)")};
  }

  &::placeholder {
    color: #6c757d;
    font-weight: 400;
  }

  &:hover:not(:focus) {
    border-color: ${(props) => (props.$hasError ? "#e74c3c" : "#adb5bd")};
  }
`;

const AuthSubmitButton = styled.button<{ $disabled?: boolean }>`
  padding: ${pxIntoRem(14)};
  background: ${(props) => (props.$disabled ? "#e9ecef" : "#212529")};
  color: ${(props) => (props.$disabled ? "#6c757d" : "white")};
  border: none;
  border-radius: ${pxIntoRem(8)};
  font-size: ${pxIntoRem(15)};
  font-weight: 500;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  margin-top: ${pxIntoRem(8)};

  &:hover {
    background: ${(props) => (props.$disabled ? "#e9ecef" : "#343a40")};
    transform: ${(props) => (props.$disabled ? "none" : "translateY(-1px)")};
  }

  &:active {
    transform: ${(props) => (props.$disabled ? "none" : "translateY(0)")};
  }
`;

const AuthErrorMessage = styled.div`
  color: #e74c3c;
  text-align: center;
  margin-top: ${pxIntoRem(16)};
  padding: ${pxIntoRem(12)} ${pxIntoRem(16)};
  background: #fdf2f2;
  border-radius: ${pxIntoRem(6)};
  border: ${pxIntoRem(1)} solid #fbb;
  font-size: ${pxIntoRem(14)};
  line-height: 1.4;
`;

export {
  AuthBlock,
  AuthErrorMessage,
  AuthForm,
  AuthFormGroup,
  AuthFormTitle,
  AuthFormWrapper,
  AuthInput,
  AuthSubmitButton,
};
